module.exports = __webpack_public_path__ + "static/media/phyxable_logo.96f76102.svg";